import { updateObject } from "../../../../shared";
import {
  emptyString,
  globalConstants,
  loginConstants,
  storesConstants,
} from "../../constants";
import { getItemFromStorage } from "../../../../system/storage";

//Destructuring global constants
const { SUCCESS, REQUEST, FAILURE } = globalConstants;

//Destructuring store constants
const {
  BRAND_ID,
  RESET_STORE,
  UPDATE_GROUP,
  SINGLE_STORE,
  FILTER_STORES,
  FETCH_ALL_STORE,
  FETCH_ALL_BRANDS,
  FETCH_STORE_BY_ID,
  FETCH_STORE_DETAILS,
  FETCH_BRAND_LOCATIONS,
  FETCH_ALL_STORE_BY_BRAND_ID,
  GET_ALL_BRANDS_FOR_FILTER_DROPDOWN,
} = storesConstants;

const brandId = getItemFromStorage(loginConstants.BRAND_ID) || emptyString;

//Default state of account reducer
const initialState = {
  store: {},
  stores: [],
  allStores: [],
  allBrands: [],
  allActiveBrands: [],
  filterStores: [],
  storeDetails: {},
  selectedStore: {},
  brandId: brandId,
  isStoreExistInFR: false,
  allBrandsForFilterDropdown: [],
  allStoresByBrandId: [],
};

//Filtering common data
const getDifference = (array1, array2) => {
  return array1.filter((object1) => {
    return !array2.some((object2) => {
      return object1.id === object2.id;
    });
  });
};

//Manipulating the state of account based on actions and returning the state
export const storesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_STORE + SUCCESS: {
      let setA = [...action.data.data];
      let setB = [...state.allStores];
      let value = getDifference(setA, setB);
      return updateObject(state, {
        allStores: [...state.allStores, ...value],
        filterStores: [],
      });
    }
    case FETCH_ALL_STORE_BY_BRAND_ID + SUCCESS: {
      return updateObject(state, {
        allStoresByBrandId: action.data.stores,
      });
    }
    case FILTER_STORES + SUCCESS: {
      return updateObject(state, {
        filterStores: [...action.data.data],
        allStores: [],
      });
    }
    case SINGLE_STORE + SUCCESS: {
      return updateObject(state, {
        selectedStore: action.data,
      });
    }
    case FETCH_STORE_DETAILS + SUCCESS: {
      return updateObject(state, {
        storeDetails: action.data,
      });
    }
    case FETCH_ALL_BRANDS + SUCCESS: {
      return updateObject(state, {
        allBrands: action.data.data,
      });
    }
    case GET_ALL_BRANDS_FOR_FILTER_DROPDOWN + SUCCESS: {
      return updateObject(state, {
        allBrandsForFilterDropdown: action.data.data,
      });
    }
    case FETCH_BRAND_LOCATIONS + SUCCESS: {
      return updateObject(state, {
        stores: action.data.data,
      });
    }
    case FETCH_BRAND_LOCATIONS + REQUEST: {
      return updateObject(state, {
        stores: [],
      });
    }
    case FETCH_STORE_BY_ID + SUCCESS: {
      return updateObject(state, {
        store: action.data,
      });
    }
    case RESET_STORE + SUCCESS: {
      return updateObject(state, {
        allStores: [],
      });
    }
    case BRAND_ID + SUCCESS: {
      return updateObject(state, {
        brandId: action.data,
      });
    }
    case UPDATE_GROUP + FAILURE: {
      return updateObject(state, {
        allStores: state.allStores,
      });
    }
    default:
      return state;
  }
};
